const ScrollHandler = () => {

	//
	// Scroll hide/reveal navigation
	// Enable it after a second so the page has time to load and possibly scroll
	const body = document.body;
	const classNameUp = 'js-scroll-up';
	const classNameDn = 'js-scroll-dn';
	const classNameScrolled = 'js-scroll';
	const breakpoint1 = 200;
	const breakpoint2 = 300;
	let lastScroll = window.scrollY - 1;

	const handleScroll = () => {
		const currentScroll = window.scrollY;
		if(currentScroll <= breakpoint1) {
			body.classList.remove(classNameUp);
			body.classList.remove(classNameDn);
			body.classList.remove(classNameScrolled);
			lastScroll = currentScroll;
			return;
		}
		body.classList.add(classNameScrolled);

		if(currentScroll > breakpoint2 && currentScroll < lastScroll) {
			body.classList.remove(classNameDn);
			body.classList.add(classNameUp);
		}
		else if(currentScroll > breakpoint2 && currentScroll > lastScroll) {
			body.classList.remove(classNameUp);
			body.classList.add(classNameDn);
		}

		lastScroll = currentScroll;
	};

	setTimeout(() => {
		window.addEventListener('scroll', handleScroll);
	}, 1000);
	handleScroll();
};

export default ScrollHandler;